import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { db, setDoc, serverTimestamp, doc, getDoc } from "../../firebase";

const AddNote = ({ orderId, currentLocation }) => {
  const { t, i18n } = useTranslation();
  const [note, setNote] = useState("");
  const [existingNotes, setExistingNotes] = useState([]);

  useEffect(() => {
    getNotes();
  }, []);

  const getNotes = async () => {
    const docRef = doc(db, currentLocation + "_" + "orders", orderId);
    const docSnap = await getDoc(docRef);

    if (docSnap.data()?.notes) {
      setExistingNotes([...docSnap.data().notes]);
      console.log("Document data:", docSnap.data());
    } else {
      console.log("No such document!");
    }
  };
  const handleSubmit = async () => {
    if (note && note.length > 0) {
      const ref = doc(db, currentLocation + "_" + "orders", orderId);
      setDoc(
        ref,
        {
          notes: [...existingNotes, { note: note }],
        },
        { merge: true }
      );
      getNotes();
      setNote("");
    }
  };
  return (
    <div>
      <Box
        sx={{
          pt: 2,
          p: 3,
          backgroundColor: "#fafafa",
          border: "1px solid #e0e0e0",
          mr: 2,
          ml: 1,
          mt: 3,
        }}
      >
        <Box>
          <Box sx={{ fontSize: "13px", fontWeight: 600 }}>
            <InventoryOutlinedIcon
              sx={{ position: "relative", top: "+6px", color: "gray" }}
            />{" "}
            이 주문에 대해서 남겨진 기록들
          </Box>
          {existingNotes.map((note) => {
            return (
              <Box
                sx={{
                  backgroundColor: "white",
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  mt: 2,
                  px: 4,
                  color: "#508bed",
                }}
              >
                {note.note}
              </Box>
            );
          })}
        </Box>
        <Box sx={{ fontSize: "13px", fontWeight: 600, mt: 3 }}>
          <InventoryOutlinedIcon
            sx={{ position: "relative", top: "+6px", color: "gray" }}
          />{" "}
          이 주문에 대해서 기록 남기기
        </Box>
        <TextField
          value={note}
          onChange={(e) => setNote(e.target.value)}
          multiline
          rows={3}
          sx={{
            width: 1,
            backgroundColor: "white",
            mt: 2,
          }}
        />
        <button
          onClick={handleSubmit}
          className="custom_btn"
          style={{ width: "300px", marginTop: "20px" }}
        >
          {t("Submit")}
        </button>
      </Box>
    </div>
  );
};

export default AddNote;
